var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEarlychekout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.708,
    height: 17.495,
    viewBox: "0 0 16.708 17.495",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-early-checkout-4684688",
    transform: "translate(-90.694 -8.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8479",
    "data-name": "Path 8479",
    d: "M102.088,22.223a.2.2,0,0,0-.2.2v.2a.634.634,0,0,1-.632.634H98.461V11.746a.876.876,0,0,0-.582-.823L92.092,8.892h9.163a.632.632,0,0,1,.632.632v3.923a.2.2,0,1,0,.4,0V9.523a1.038,1.038,0,0,0-1.039-1.039H91.736A1.038,1.038,0,0,0,90.7,9.523a.134.134,0,0,0,.008.035.635.635,0,0,0-.011.071V22.992a.876.876,0,0,0,.582.823L97.3,25.93a.9.9,0,0,0,.292.049.872.872,0,0,0,.867-.872V23.67h2.794a1.041,1.041,0,0,0,1.039-1.042v-.2a.2.2,0,0,0-.205-.2Zm-4.035,2.884a.452.452,0,0,1-.2.377.464.464,0,0,1-.421.06l-6.022-2.116a.463.463,0,0,1-.309-.437V9.63a.452.452,0,0,1,.2-.377.44.44,0,0,1,.262-.087.446.446,0,0,1,.156.027l6.025,2.116a.465.465,0,0,1,.312.437V25.107Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8480",
    "data-name": "Path 8480",
    d: "M231.742,264.05a.957.957,0,1,0,.957.957A.958.958,0,0,0,231.742,264.05Zm0,1.509a.552.552,0,1,1,.552-.552A.552.552,0,0,1,231.742,265.559Z",
    transform: "translate(-135.577 -247.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8481",
    "data-name": "Path 8481",
    d: "M364.8,177.711a.2.2,0,0,0-.038.284,3.647,3.647,0,1,1-2.909-1.446.2.2,0,1,0,0-.4,4.051,4.051,0,1,0,3.231,1.607.2.2,0,0,0-.284-.041Z",
    transform: "translate(-258.503 -162.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8482",
    "data-name": "Path 8482",
    d: "M391.32,212.714a2.969,2.969,0,1,0,2.969-2.969A2.974,2.974,0,0,0,391.32,212.714Zm5.522-.191a.2.2,0,0,0-.057-.011h-.508a.2.2,0,0,0,0,.4h.508a.21.21,0,0,0,.057-.011,2.567,2.567,0,0,1-2.362,2.362.214.214,0,0,0,.011-.057V214.7a.2.2,0,0,0-.4,0v.508a.193.193,0,0,0,.011.057,2.565,2.565,0,0,1-2.362-2.362.2.2,0,0,0,.057.011h.508a.2.2,0,1,0,0-.4h-.508a.21.21,0,0,0-.057.011,2.562,2.562,0,0,1,2.362-2.362.216.216,0,0,0-.011.057v.508a.2.2,0,0,0,.4,0v-.508a.191.191,0,0,0-.011-.057A2.562,2.562,0,0,1,396.842,212.522Z",
    transform: "translate(-290.94 -194.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8483",
    "data-name": "Path 8483",
    d: "M448.366,253.985a.2.2,0,0,0-.4,0v.741a.634.634,0,0,0-.41.426h-.364a.2.2,0,1,0,0,.4h.377a.643.643,0,1,0,.8-.834v-.738Zm-.205,1.585a.238.238,0,1,1,.238-.238A.235.235,0,0,1,448.161,255.57Z",
    transform: "translate(-344.813 -237.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8484",
    "data-name": "Path 8484",
    d: "M501.021,113.343a1.771,1.771,0,1,0-1.771-1.771A1.774,1.774,0,0,0,501.021,113.343Zm0-3.135a1.364,1.364,0,1,1-1.364,1.364A1.369,1.369,0,0,1,501.021,110.207Z",
    transform: "translate(-395.393 -98.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8485",
    "data-name": "Path 8485",
    d: "M530.622,148.869a.207.207,0,0,0,.137.079c.008,0,.016,0,.027,0a.2.2,0,0,0,.126-.044l.891-.692a.2.2,0,0,0-.249-.32l-.727.566-.194-.254a.2.2,0,1,0-.323.246Z",
    transform: "translate(-425.412 -134.879)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEarlychekout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/earlychekout.5fd9beba.svg";
export { ForwardRef as ReactComponent };